(function($){

	if( $('.gform_body').length )
	{
		$(document).on('gform_page_loaded', addAutocomplete );
		gform.addAction('gpnf_init_nested_form', addAutocompleteToNestedForm);
		gform.addAction('gpnf_init_nested_form', mirrorEmailValueToConfirmation);
	}

	/**
	 * Attach events to the correct fields
	 */
	function addAutocomplete( event, form_id, current_page ) {

		const formBody = $(document).find('#gform_page_' + form_id + '_' + current_page);

		// Initialize the autocomplete
		formBody.find('.js-autocomplete-input-zipcode input').on('blur', initAutocomplete );
		formBody.find('.js-autocomplete-input-number input').on('blur', initAutocomplete );
	}

	/**
	 * Attach events to nested forms
	 */
	function addAutocompleteToNestedForm( childFormId, gpnf ) {
		setTimeout(function() {
			const form = $(document).find('#gform_' + childFormId);
			form.find('.js-autocomplete-input-zipcode input').on('blur', initAutocomplete );
			form.find('.js-autocomplete-input-number input').on('blur', initAutocomplete );
		});
	}

	/**
	 * Set field value for email confirmation
	 */
	function mirrorEmailValueToConfirmation(childFormId, gpnf) {
		setTimeout(function() {
			const form = $(document).find('#gform_' + childFormId);
			const emailField = form.find('fieldset.gfield--type-email .ginput_left input');
			const emailConfirmationField = form.find('fieldset.gfield--type-email .ginput_right input');

			// Mirror the value of the email field to the confirmation field
			if( emailField.val() !== '' ){
				emailConfirmationField.val( emailField.val() );
			}
		});
	}

	/**
	 * Catch the blur event
	 *
	 * @param {object} event
	 */
	function initAutocomplete( event )
	{
		// Get values
		const zipcode = getFieldValue( $(this), 'js-autocomplete-input-zipcode' );
		const number = getFieldValue( $(this), 'js-autocomplete-input-number' );

		// Get the closest street and city fields
		const street = $(this).parents('.gfield').nextAll('.js-autocomplete-output-street').first().find('input');
		const city = $(this).parents('.gfield').nextAll('.js-autocomplete-output-city').first().find('input');

		// Set notice wrapper
		const notice = $(this).parents('.gfield').nextAll('.js-autocomplete-notice-wrapper').first();

		// Setup regex for zipcode
		const regexZipcode = /^(\d{4})([A-Z]{2})$/i;

		// Check zipcode input and number
		if( zipcode.length === 6 && zipcode.match(regexZipcode) && number.length > 0 ) {

			// Get full address
			const authKey = 'mg3FN9BefhRHFH2t';
			const requestUri = 'https://api.pro6pp.nl/v2/autocomplete/nl?authKey=' + authKey + '&postalCode=' + zipcode + '&streetNumberAndPremise=' + number;

			// Disable when filling happens
			street.attr('disabled', true);
			street.attr('city', true);

			// AJAX Request
			$.ajax({
				url: requestUri,
				type: 'GET',
				success: function(response) {

					// Hide notice
					notice.html('');

					// Set default overwrite
					let overwrite = true;

					// Check if there are already values in the fields. If so: ask to override them
					if( (street.val().length > 0 && street.val() != response.street) || (city.val().length > 0 && city.val() != response.municipality) ) {
						overwrite = confirm( 'Wil je de huidige waarden van de straat- en plaatsnaam overschrijven?' );
					}

					// WHen confirmed, (re)place values
					if( overwrite ) {
						// Add Street
						street.attr('disabled', false)
								.val( response.street )
								.parents('.gfield').removeClass('is--disabled');

						// Add City
						city.attr('disabled', false)
							.val( response.municipality )
							.parents('.gfield').removeClass('is--disabled');
					}

				},
				error: function(error) {

					// Default error message
					let errorMsg = 'Er ging iets mis met het opzoeken van de gegevens. Probeer het opnieuw of vul de gegevens handmatig in.';

					// Handle error!
					if( error.statusText === 'error' && error.responseJSON.error_id != undefined )
					{
						const errorCode = error.responseJSON.error_id;

						if(errorCode  === 'NO_RESULTS_FOUND' ) {
							errorMsg = 'Geen resultaten gevonden voor deze postcode-huisnummer combinatie. Probeer opnieuw of vul de gegevens handmatig in.';
						}
						else if( errorCode === 'MISSING_PARAMETER' ) {
							errorMsg = 'Dit huisnummer zou een toevoeging moeten hebben.';
						}

					}

					// Return error
					addNotice( 'error', notice, errorMsg );

					// Clear the street and city fields to be filled by hand
					street.attr('disabled', false)
						  .parents('.gfield').removeClass('is--disabled');

					city.attr('disabled', false)
						.parents('.gfield').removeClass('is--disabled');

					return false;
				}
			});
		}

	}

	/**
	 * Add error to element
	 * @param {HTMLElement} element
	 * @param {string} message
	 */
	function addNotice( type, element, message ) {
		element.html('<div class="' + type + '">' + message + '</div>')
	}

	/**
	 * Get the correct value of matching fields
	 *
	 * @param {HTMLElement} currentElement
	 * @param {string} className
	 * @returns {string} value
	 */
	function getFieldValue( currentElement, className ){

		// Is this the numbers field, return current value
		if( currentElement.parents('.gfield').hasClass(className) ) {
			return currentElement.val();
		}

		// When currentElement is zipcode, searching for number, return the next field
		if( currentElement.parents('.gfield').hasClass('js-autocomplete-input-zipcode') ){
			return currentElement.parents('.gfield').next('.gfield.' + className).find('input').val();
		}
		// When currentElement is number, searching for zipcode, return the prev field
		else
		{
			return currentElement.parents('.gfield').prev('.gfield.' + className).find('input').val();
		}

	}


})(jQuery);